import React from "react";
import VideoPlayer from "./ReactPlayer";
import { NavLink } from "react-router-dom";

const HowItWork = () => {
  return (
    <section className="section-p">
      <div className="page-width">
        <div className="player">
          <div className="player__section1">
            <div className="player__section1__right">
              <h1 className="player__section1__right-txt1 text-jost-sb-50-wt txt-center">
                How It works
              </h1>
              <p className="player__section1__right-para text-ops-rg-16-wt txt-center">
                Download our app from IOS or Android and create and account.
                Before starting your round select the club, course, starting
                hole and tees you are playing from and the app will record your
                progress around the course. The time taken to play each hole
                will be compared to the time the club have predefined it should
                (reasonably) take to play each hole thus ensuring all golfers
                play at a reasonable pace and any slow play will be immediately
                identified and can be rectified quickly by the club officials.
              </p>
              <VideoPlayer />
              <div className="player__section1__right__btn">
                <NavLink
                  to="/contact"
                  target="_self"
                  className="res-btn-primary"
                >
                  ENQUIRE
                </NavLink>
                <NavLink to="/faq" target="_self" className="res-btn-secondary">
                  FAQ's
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWork;
